const _ = require("underscore");
const Reflux = require("reflux");
const FunnelMovesActions = require("../actions/funnel-moves-actions");

const FunnelMovesStore = Reflux.createStore({
  state: {
    originFunnelId: null,
    destinationFunnelId: null,
    funnels: [],
    loading: true,
    moves: {
      loading: false,
      failed: false,
      data: null
    }
  },

  init: function() {
    this.listenTo(FunnelMovesActions.loadFunnels.completed, this.onLoadFunnelsCompleted);
    this.listenTo(FunnelMovesActions.fetchData, this.onFetchStarted);
    this.listenTo(FunnelMovesActions.fetchData.completed, this.onFetchCompleted);
    this.listenTo(FunnelMovesActions.fetchData.failed, this.onFetchFailed);
    this.listenTo(FunnelMovesActions.setOriginFunnelId, this.setOriginFunnelId);
    this.listenTo(FunnelMovesActions.setDestinationFunnelId, this.setDestinationFunnelId);
    this.listenTo(FunnelMovesActions.recalculateFunnels, this.recalculateFunnels);

    this.state = this.getInitialState();
  },

  getInitialState: function() {
    return this.state;
  },

  onLoadFunnelsCompleted: function(funnels) {
    this.state = {
      loading: false,
      funnels: funnels
    };

    this.trigger(this.state);
  },

  onFetchStarted: function() {
    this.state = {
      moves: {
        loading: true
      }
    };

    this.trigger(this.state);
  },

  onFetchCompleted: function(data) {
    this.state = {
      moves: {
        loading: false,
        data: data
      }
    };

    this.trigger(this.state);
  },

  onFetchFailed: function(error) {
    this.state = {
      moves: {
        loading: false,
        failed: true
      }
    };

    this.trigger(this.state);
  },

  setOriginFunnelId: function(originFunnelId) {
    this.state = { originFunnelId };

    this.trigger(this.state);
  },

  setDestinationFunnelId: function(destinationFunnelId) {
    this.state = { destinationFunnelId };

    this.trigger(this.state);
  },

  recalculateFunnels: function(funnels, selectedFunnelId) {
    var originFunnel = _.chain(funnels)
      .filter(function(funnel) { return funnel.id != selectedFunnelId; })
      .first()
      .value();

    this.state = {
      originFunnelId: originFunnel ? originFunnel.id : null,
      destinationFunnelId: selectedFunnelId
    };

    this.trigger(this.state);
  }
});

module.exports = FunnelMovesStore;



// WEBPACK FOOTER //
// ./app/screens/Dashboard/stores/funnel-moves-store.js